import { orderSections } from './orderSections';
import type { CastNode } from '../types';

/**
 * Pre-order walk over a Cast tree. The visitor is called on the root first,
 * then recursively on every descendant. Root visits its sections in canonical
 * serializer order (headers → body → footers; see `orderSections`).
 */
export function walkCast(node: CastNode, visitor: (node: CastNode) => void): void {
  visitor(node);
  switch (node.type) {
    case 'root':
      for (const child of orderSections(node.children)) walkCast(child, visitor);
      break;
    case 'link':
    case 'paragraph':
    case 'section':
    case 'table':
    case 'tableCell':
    case 'tableRow':
      for (const child of node.children) walkCast(child, visitor);
      break;
    case 'selectionEnd':
    case 'selectionStart':
    case 'text':
      break;
  }
}
